import { render, staticRenderFns } from "./modelManager.vue?vue&type=template&id=b5765368&scoped=true"
import script from "./modelManager.vue?vue&type=script&lang=js"
export * from "./modelManager.vue?vue&type=script&lang=js"
import style0 from "./modelManager.vue?vue&type=style&index=0&id=b5765368&prod&lang=less"
import style1 from "./modelManager.vue?vue&type=style&index=1&id=b5765368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5765368",
  null
  
)

export default component.exports